import { store } from 'v3/data/store';
import { groupsAdminSlice } from 'v3/data/store/groupAdmin';
import { IGroupAdminGroup, IGroupAdminItem, IGroupsAdminList } from 'v3/data/store/groupAdmin/types';

export const setFilterCurrentPage = (value: number) => {
  store.dispatch(groupsAdminSlice.actions.setFilterCurrentPage(value));
};

export const setFilterRowsPerPage = (value: number) => {
  store.dispatch(groupsAdminSlice.actions.setFilterRowsPerPage(value));
};

export const setGroupAdminList = (value: IGroupsAdminList) => {
  store.dispatch(groupsAdminSlice.actions.setGroupAdminList(value));
};

export const setAllGroups = (value: IGroupAdminGroup[]) => {
  store.dispatch(groupsAdminSlice.actions.setAllGroups(value));
};

export const setGroupAdminSelected = (value: IGroupAdminItem) => {
  store.dispatch(groupsAdminSlice.actions.setGroupAdminSelected(value));
};

export const setFilterGroupAdminName = (value: string) => {
  store.dispatch(groupsAdminSlice.actions.setFilterGroupAdminName(value));
};
export const clearFilterGroupAdmin = () => {
  store.dispatch(groupsAdminSlice.actions.clearFilterGroupAdmin());
};

export const setFilterGroupAdminStoreGroupId = (value: string[]) => {
  store.dispatch(groupsAdminSlice.actions.setFilterGroupAdminStoreGroupId(value));
};
